import { render, staticRenderFns } from "./PersonEntryCard.vue?vue&type=template&id=2acec6bd"
import script from "./PersonEntryCard.vue?vue&type=script&lang=js"
export * from "./PersonEntryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports